module.exports = require('./helpers/bundle-url').getBundleURL('455Cc') + "logo-dark.eefe0b7f.svg";